export { default as ProgressBar } from './component';
